export interface EventResource {
  id: string;
  nom: string;
  type: string;
  responsableId: string;
  responsableNom?: string;
  description?: string;
  superType: SuperTypeEnum;
}

export enum SuperTypeEnum {
  Ressource = "ressource",
  Profil = "profil",
}